import PropTypes from 'prop-types';
import { Typography, makeStyles } from '@material-ui/core';
import CustomDrawer from '../customDrawer';
import TextBoxWithTooltip from '../textBoxWithTooltip';
import UserAvatar from '../userAvatar';
import RichTextPreview from '../richTextPreview';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  root: {
    width: '100%',
  },
  review: {
    marginBottom: spacing(6),
  },
  cyclesWrapper: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 16,
    marginBottom: spacing(4.5),
    width: '100%',
  },
  reviewsWrapper: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 16,
    width: '100%',
  },
  questionsWrapper: {
    display: 'grid',
    gap: 24,
    width: '100%',
  },
  question: {
    wordBreak: 'break-word',
    marginBottom: spacing(4.5),
  },
  answersWrapper: {
    display: 'grid',
    gap: 16,
    width: '100%',
  },
  answer: {
    boxSizing: 'border-box',
    border: `1px solid ${primary.bluish4}`,
    borderRadius: 4,
    padding: spacing(4),
    width: '100%',
  },
  user: {
    marginBottom: spacing(4),
  },
}));

const EmployeeCycleReviewAnswersPreview = ({
  translations,
  title,
  isOpened,
  cycle = null,
  cycleToCompare = null,
  review = null,
  reviewAnswers = [],
  compareReviewAnswers = [],
  onClose,
}) => {
  const classes = useStyles();

  return (
    <CustomDrawer title={title} isOpened={isOpened} onClose={onClose}>
      <div className={classes.root}>
        {review?.name && (
          <TextBoxWithTooltip
            className={classes.review}
            variant="h2"
            text={review.name}
          />
        )}
        <div className={classes.cyclesWrapper}>
          {cycle?.title && (
            <TextBoxWithTooltip variant="h5" text={cycle.title} />
          )}
          {cycleToCompare?.title ? (
            <TextBoxWithTooltip variant="h5" text={cycleToCompare.title} />
          ) : (
            <div />
          )}
        </div>
        <div className={classes.reviewsWrapper}>
          <div className={classes.questionsWrapper}>
            {reviewAnswers.map(question => (
              <div key={`question_${question.id}`}>
                <Typography className={classes.question} variant="h5">
                  {question.text}
                </Typography>
                <div className={classes.answersWrapper}>
                  {question.replies.map(reply => (
                    <div
                      key={`employee_answer__${reply.reviewer.id}`}
                      className={classes.answer}
                    >
                      <UserAvatar
                        className={classes.user}
                        variant="subtitle2"
                        user={reply.reviewer}
                        small
                        caption
                      />
                      <RichTextPreview
                        text={
                          reply.not_applicable
                            ? translations.neutral.notApplicable
                            : reply.reply
                        }
                      />
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
          <div className={classes.questionsWrapper}>
            {compareReviewAnswers.map(question => (
              <div key={`question_${question.id}`}>
                <Typography className={classes.question} variant="h5">
                  {question.text}
                </Typography>
                <div className={classes.answersWrapper}>
                  {question.replies.map(reply => {
                    return (
                      <div
                        key={`employee_answer__${reply.reviewer.id}`}
                        className={classes.answer}
                      >
                        <UserAvatar
                          className={classes.user}
                          variant="subtitle2"
                          user={reply.reviewer}
                          small
                          caption
                        />
                        <RichTextPreview
                          text={
                            reply.not_applicable
                              ? translations.neutral.notApplicable
                              : reply.reply
                          }
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </CustomDrawer>
  );
};

EmployeeCycleReviewAnswersPreview.propTypes = {
  translations: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  isOpened: PropTypes.bool.isRequired,
  cycle: PropTypes.object,
  cycleToCompare: PropTypes.object,
  review: PropTypes.object,
  reviewAnswers: PropTypes.arrayOf(PropTypes.object),
  compareReviewAnswers: PropTypes.arrayOf(PropTypes.object),
  onClose: PropTypes.func.isRequired,
};

export default EmployeeCycleReviewAnswersPreview;
